var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getLanguageFromStorage } from "syf-js-utilities";
import Collapse from "syf-component-library/ui/atoms/Collapse";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { DesktopCardContainer } from "../../ui/layouts/DesktopCard/DesktopCard.styles";
import { CollapseCardContainer, CollapseHeader, MobileCardContainer, } from "../../ui/layouts/MobileCard/MobileCard.styles";
import ErrorComponent from "./ErrorComponent";
import { ErrorContainer, ErrorMobileWrapper } from "./ErrorWrapper.styles";
import { useConfig } from "../../hooks/useConfig";
import { CardHeader } from "../../ui/molecules/CardHeader";
import i18n from "../../strings/i18n";
var ErrorWrapper = function (_a) {
    var isError = _a.isError, children = _a.children, isExpandedByDefault = _a.isExpandedByDefault;
    var windowWidth = useWindowSize();
    var hosts = useConfig().hosts;
    var lang = getLanguageFromStorage();
    var syfLogoSource = "".concat(hosts === null || hosts === void 0 ? void 0 : hosts.assets, "assets/account-card-mfe/logo.svg");
    var _b = useState(isExpandedByDefault || false), isExpanded = _b[0], setIsExpanded = _b[1];
    var collapseIcon = isExpanded ? faChevronUp : faChevronDown;
    var handleHeaderOnClick = function () {
        setIsExpanded(isExpandedByDefault || !isExpanded);
    };
    var headerData = {
        displayName: i18n({ error: "error" }),
        accountLast4: "",
        portfolioLogo: syfLogoSource,
        isExpandedByDefault: isExpandedByDefault || false,
        isLoan: false,
        isLinkEnabled: false,
        isNickNameButton: false,
        accountId: "",
        isSecuredInstallment: false,
        isError: true,
    };
    if (isError) {
        return !windowWidth.isLessThanMobile ? (_jsx(DesktopCardContainer, { children: _jsxs(ErrorContainer, { children: [_jsx(CardHeader, __assign({}, headerData, { notificationList: [] })), _jsx(ErrorComponent, {})] }) })) : (_jsx(ErrorMobileWrapper, { children: _jsxs(MobileCardContainer, __assign({ lang: lang, isExpanded: isExpanded }, { children: [_jsxs(CollapseHeader, __assign({ "aria-expanded": isExpanded, onClick: handleHeaderOnClick }, { children: [_jsx(CardHeader, __assign({}, headerData, { notificationList: [] })), !isExpandedByDefault && _jsx(FontAwesomeIcon, { icon: collapseIcon })] })), _jsx(Collapse, __assign({ expand: isExpanded, id: "Error-collased-header" }, { children: _jsx(CollapseCardContainer, __assign({ lang: lang }, { children: _jsx(ErrorComponent, {}) })) }))] })) }));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
};
export default ErrorWrapper;
//# sourceMappingURL=ErrorWrapper.js.map